export const CLIENT_FORM_REQUEST = "CLIENT_FORM_REQUEST";
export const CLIENT_FORM_SUCCESS = "CLIENT_FORM_SUCCESS";
export const CLIENT_FORM_FAIL = "CLIENT_FORM_FAIL";